import axios from 'axios'
import qs from 'qs'
import { wechatAuthCode } from '@/utils/wx'
import store from '@/store'
import { logout, fs_login } from '@/utils/app'

// 创建axios实例
const httpService = axios.create({
  baseURL: 'https://api.foshanplus.com',
  timeout: 240000 // 请求超时时间
})

// request拦截器
httpService.interceptors.request.use(
  (config) => {
    if (config.method === 'post') {
      if (config.type != 'file') {
        if (config.type == 'json') {
          config.data = JSON.stringify(config.data)
        } else {
          config.data = qs.stringify(config.data)
        }
      }
    }
    return config
  },
  (error) => {
    // 请求错误处理
    Promise.reject(error)
  }
)

// response拦截器
httpService.interceptors.response.use(
  (response) => {
    // 统一处理状态
    const res = response.data
    if (res.ret != 1) {
      // 需自定义
      // 返回异常
      if (res.ret == 401) {
        store.commit('setToken', '')
        wechatAuthCode()
        const isReLogin = localStorage.getItem('isReLogin')
        if (isReLogin != 1) {
          localStorage.setItem('isReLogin', 1)
          if (logout()) fs_login()
        }
      }
      return Promise.reject({
        ret: res.ret,
        message: res.msg
      })
    } else {
      return res
    }
  },
  // 处理处理
  (error) => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '错误请求'
          break
        case 401:
          error.message = '未授权，请重新登录'
          break
        case 403:
          error.message = '拒绝访问'
          break
        case 404:
          error.message = '请求错误,未找到该资源'
          break
        case 405:
          error.message = '请求方法未允许'
          break
        case 408:
          error.message = '请求超时'
          break
        case 500:
          error.message = '服务器端出错'
          break
        case 501:
          error.message = '网络未实现'
          break
        case 502:
          error.message = '网络错误'
          break
        case 503:
          error.message = '服务不可用'
          break
        case 504:
          error.message = '网络超时'
          break
        case 505:
          error.message = 'http版本不支持该请求'
          break
        default:
          error.message = `未知错误${error.response.status}`
      }
    } else {
      error.message = '连接到服务器失败'
    }
    return Promise.reject(error)
  }
)

/*网络请求部分*/

/*
 *  get请求
 *  url:请求地址
 *  params:参数
 * */
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    httpService({
      url: url,
      method: 'get',
      params
    })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/*
 *  post请求
 *  url:请求地址
 *  params:参数
 * */
export function post(url, params = {}) {
  return new Promise((resolve, reject) => {
    httpService({
      url: url,
      method: 'post',
      data: params
    })
      .then((response) => {
        if (resolve) {
          resolve(response)
        }
      })
      .catch((error) => {
        if (reject) {
          reject(error)
        }
      })
  })
}

/*
 *  post请求
 *  url:请求地址
 *  params:json参数
 * */
export function jsonPost(url, params = {}) {
  return new Promise((resolve, reject) => {
    httpService({
      url: url,
      method: 'post',
      data: params,
      type: 'json',
      headers: { 'Content-Type': 'application/json;', token: store.state.token }
    })
      .then((response) => {
        if (resolve) {
          resolve(response)
        }
      })
      .catch((error) => {
        if (reject) {
          reject(error)
        }
      })
  })
}

/*
 *  文件上传
 *  url:请求地址
 *  params:参数
 * */
export function fileUpload(url, params = {}) {
  return new Promise((resolve, reject) => {
    httpService({
      url: url,
      method: 'post',
      data: params,
      type: 'file',
      dataType: 'json',
      processData: false, //tell jQuery not to process the data
      contentType: false
    })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/*
 *  文件上传
 *  url:请求地址
 *  params:参数
 * */
export function multiFileUploads(url, params = {}) {
  return new Promise((resolve, reject) => {
    httpService({
      url: url,
      method: 'post',
      data: params,
      type: 'file',
      dataType: 'json',
      processData: false, //tell jQuery not to process the data
      contentType: false
    })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export default {
  get,
  post,
  fileUpload,
  multiFileUploads
}
